module.exports = __webpack_public_path__ + "static/fondation-small-img-mobile-a2806374d8b4ab879ac2e2b96f65ba3b.png";